var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon_arrow_up_svg__cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon_arrow_up_svg__cls-3",
    d: "M22.31 16.5c.58 0 1.8 1.13 1.8 1.13l12.4 12.84a1.15 1.15 0 001.63 0 1.17 1.17 0 000-1.64L24 14.23c-.16-.17-.61-.61-.88-.87a1.17 1.17 0 00-1.64 0L6.58 29a1.17 1.17 0 000 1.64 1.15 1.15 0 001.63 0l12.4-13.42a2.61 2.61 0 011.67-.72"
  }))));
}

export default SvgIconArrowUp;